// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loader-container {
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
}


/* Start::Loader */
.loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 160px;
    width: 170px;
    position: relative;
    margin: 0px;
    padding: 0px;
}

.loading_circle {
    border: 5px transparent solid;
    position: absolute;
    width: 100px;
    height: 100px;
    border-radius: 69%;
}

.loading_blue {
    top: 0px;
    border-top: 5px lightblue solid;
    animation-delay: 4s;
    animation: blue_animation 1.5s infinite;
}

.loading_blue:after {
    position: absolute;
    content: "";
    width: 10px;
    height: 10px;
    background: lightblue;
    border-radius: 69%;
    right: 5px;
    top: 10px;
    box-shadow: 0px 0px 20px lightblue;
}

.loading_blue:before {
    content: " ";
    width: 5px;
    height: 5px;
    position: absolute;
    background: lightblue;
    top: 8.8px;
    left: 9px;
    border-radius: 69%;
}

.loading_coral {
    left: 0px;
    bottom: 0px;
    border-top: 5px #FD5857 solid;
    animation: coral_animation 1.5s infinite;
}

.loading_coral:after {
    position: absolute;
    content: "";
    width: 10px;
    height: 10px;
    background: #FD5857;
    border-radius: 69%;
    right: 5px;
    top: 10px;
    box-shadow: 0px 0px 20px #FD5857;
}

.loading_coral:before {
    content: " ";
    width: 5px;
    height: 5px;
    position: absolute;
    background: #FD5857;
    top: 8.8px;
    left: 9px;
    border-radius: 69%;
}

.loading_orange {
    right: 0px;
    bottom: 0px;
    border-top: 5px #F79D41 solid;
    animation: orange_animation 1.5s infinite;
}

.loading_orange:after {
    position: absolute;
    content: "";
    width: 10px;
    height: 10px;
    background: #F79D41;
    border-radius: 69%;
    right: 5px;
    top: 10px;
    box-shadow: 0px 0px 20px #F79D41;
}

.loading_orange:before {
    content: " ";
    width: 5px;
    height: 5px;
    position: absolute;
    background: #F79D41;
    top: 8.8px;
    left: 9px;
    border-radius: 69%;
}

@keyframes blue_animation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes coral_animation {
    0% {
        transform: rotate(240deg);
    }

    100% {
        transform: rotate(600deg);
    }
}

@keyframes orange_animation {
    0% {
        transform: rotate(120deg);
    }

    100% {
        transform: rotate(480deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/Loader/Loader.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,eAAe;AACnB;;;AAGA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,+BAA+B;IAC/B,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,6BAA6B;IAC7B,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["#loader-container {\n    background-color: #FFFFFF;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100vw;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 999999;\n}\n\n\n/* Start::Loader */\n.loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 160px;\n    width: 170px;\n    position: relative;\n    margin: 0px;\n    padding: 0px;\n}\n\n.loading_circle {\n    border: 5px transparent solid;\n    position: absolute;\n    width: 100px;\n    height: 100px;\n    border-radius: 69%;\n}\n\n.loading_blue {\n    top: 0px;\n    border-top: 5px lightblue solid;\n    animation-delay: 4s;\n    animation: blue_animation 1.5s infinite;\n}\n\n.loading_blue:after {\n    position: absolute;\n    content: \"\";\n    width: 10px;\n    height: 10px;\n    background: lightblue;\n    border-radius: 69%;\n    right: 5px;\n    top: 10px;\n    box-shadow: 0px 0px 20px lightblue;\n}\n\n.loading_blue:before {\n    content: \" \";\n    width: 5px;\n    height: 5px;\n    position: absolute;\n    background: lightblue;\n    top: 8.8px;\n    left: 9px;\n    border-radius: 69%;\n}\n\n.loading_coral {\n    left: 0px;\n    bottom: 0px;\n    border-top: 5px #FD5857 solid;\n    animation: coral_animation 1.5s infinite;\n}\n\n.loading_coral:after {\n    position: absolute;\n    content: \"\";\n    width: 10px;\n    height: 10px;\n    background: #FD5857;\n    border-radius: 69%;\n    right: 5px;\n    top: 10px;\n    box-shadow: 0px 0px 20px #FD5857;\n}\n\n.loading_coral:before {\n    content: \" \";\n    width: 5px;\n    height: 5px;\n    position: absolute;\n    background: #FD5857;\n    top: 8.8px;\n    left: 9px;\n    border-radius: 69%;\n}\n\n.loading_orange {\n    right: 0px;\n    bottom: 0px;\n    border-top: 5px #F79D41 solid;\n    animation: orange_animation 1.5s infinite;\n}\n\n.loading_orange:after {\n    position: absolute;\n    content: \"\";\n    width: 10px;\n    height: 10px;\n    background: #F79D41;\n    border-radius: 69%;\n    right: 5px;\n    top: 10px;\n    box-shadow: 0px 0px 20px #F79D41;\n}\n\n.loading_orange:before {\n    content: \" \";\n    width: 5px;\n    height: 5px;\n    position: absolute;\n    background: #F79D41;\n    top: 8.8px;\n    left: 9px;\n    border-radius: 69%;\n}\n\n@keyframes blue_animation {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes coral_animation {\n    0% {\n        transform: rotate(240deg);\n    }\n\n    100% {\n        transform: rotate(600deg);\n    }\n}\n\n@keyframes orange_animation {\n    0% {\n        transform: rotate(120deg);\n    }\n\n    100% {\n        transform: rotate(480deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
